<template>
  <div
    class="slack-ua-setup-nudge-banner"
    :class="`slack-ua-setup-nudge-banner--${variant}`"
    data-qa="slack-ua-setup-nudge-banner"
  >
    <div class="slack-ua-setup-nudge-banner__content">
      <img
        v-if="slackConnected"
        class="slack-ua-setup-nudge-banner__logo"
        :src="slackLogo"
        alt=""
        width="30"
        height="30"
      >
      <span
        v-else
        class="material-symbols-rounded slack-ua-setup-nudge-banner__icon"
        aria-hidden="true"
      >notifications_active</span>
      <div
        v-if="slackConnected"
        class="slack-ua-setup-nudge-banner__info"
      >
        <p class="slack-ua-setup-nudge-banner__title">
          Get unusual activity flagged the moment they happen!
        </p>
        <p class="slack-ua-setup-nudge-banner__subtitle">
          You already have Slack connected — turn on real-time alerts for unusual activity instead of checking here.
        </p>
      </div>
      <p
        v-else
        class="slack-ua-setup-nudge-banner__message"
      >
        <strong>{{ eventsLabel }}</strong>
        <span> - {{ description }}</span>
      </p>
    </div>
    <SlackUaSetupNudgeCta
      source="Banner"
      :appearance="slackConnected ? 'primary' : 'outline'"
      :cta-kind="nudge.cta_kind"
      :connect-slack-url="nudge.connect_slack_url"
      @completed="$emit('completed')"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SlackUaSetupNudgeCta from '~/components/experiments/0229_slack_unusual_activity_setup/Cta.vue';
import { AR0231_LOGO_SLACK } from '~/rails_assets';

export default {
  name: 'SlackUaSetupNudgeBanner',
  components: { SlackUaSetupNudgeCta },
  emits: ['completed'],
  computed: {
    ...mapGetters(['slackUaSetupNudge']),
    nudge() {
      return this.slackUaSetupNudge;
    },
    slackConnected() {
      return this.nudge.cta_kind === 'enable';
    },
    variant() {
      return this.slackConnected ? 'enable' : 'connect';
    },
    slackLogo() {
      return AR0231_LOGO_SLACK;
    },
    eventCount() {
      return this.nudge.event_count || this.nudge.headline_count || 0;
    },
    eventsLabel() {
      const count = this.eventCount;

      return count === 1
        ? '1 unusual activity event in the past 7 days'
        : `${count} unusual activity events in the past 7 days`;
    },
    description() {
      return 'get notified in Slack the moment it happens.';
    },
  },
};
</script>
